import React, { useMemo, useState } from 'react'
import { Link } from 'react-router-dom'
import Fuse from 'fuse.js'

const HomePage = () => {

  const data = {
    tools: [
      {title: 'Basic Name Number Calculator', link: '/tools/basic-name-number-calculator', tags: ['Simple', 'Numerology', 'Pythagorian', 'Chaldian', 'Calculator']},
      {title: 'Basic Janmank Calculator', link: '/tools/basic-janmank-calculator', tags: ['Simple', 'Numerology', 'Pythagorian', 'Chaldian', 'Calculator']},
      {title: 'Domain Name Number Calculator', link: '/tools/basic-domain-name-number-calculator', tags: ['Basic', 'Numerology', 'Pythagorian', 'Chaldian', 'Domain']},
      {title: 'Phone Number Number Calculator', link: '/tools/phone-number-number-calculator', tags: ['Advanced', 'Numerology', 'Pythagorian', 'Chaldian', 'Phone']},
      {title: 'Business Name Number Calculator', link: '/tools/business-name-number-calculator', tags: ['Advanced', 'Numerology', 'Pythagorian', 'Chaldian', 'Business']},
    ]
  }

  const [toolsGrid, setToolsGrid] = useState(data.tools)
  const [toolsLabel, setToolsLabel] = useState(`${data.tools.length} results found`)
  const [searchQuery, setSearchQuery] = useState('');

  const fuse = useMemo(() => {
    return new Fuse(data.tools, {
      keys: ['title', 'tags'],
      threshold: 0.3,
    });
  }, [data.tools]);

  const handleSearch = (e) => {
    const query = e.target.value;
    setSearchQuery(query);

    if (!query.trim()) {
      setToolsGrid(data.tools);
      setToolsLabel(`${data.tools.length} results found`);
      return;
    }

    const results = fuse.search(query).map(result => result.item);

    if (results.length > 0) {
      setToolsGrid(results);
      setToolsLabel(`${results.length} results found`);
    } else {
      setToolsGrid(data.tools);
      setToolsLabel('0 results found');
    }
  };

  return (



    <>
    
      <section className="max-w-[85rem] py-11">

        <div className="px-11 mx-auto">   
            <label htmlFor="default-search" className="mb-2 text-sm font-medium text-gray-900 sr-only dark:text-white">Search</label>
            <div className="relative">
                <input type="search" id="default-search" className="block w-full p-4  text-sm shadow-[0_8px_30px_rgb(0,0,0,0.12)] outline-none rounded-xl bg-white" placeholder="Search Tools" value={searchQuery} onInput={handleSearch} required />
            </div>
        </div>

        <div className="px-4 py-10 sm:px-6 lg:px-8 lg:py-14 mx-auto">
          <h3 className="text-xl py-5 text-gray-500">{toolsLabel}</h3>
          <div className="grid sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-4 gap-3 sm:gap-6">

            {toolsGrid.map( (tool, index) => {return (
              <Link to={tool.link} key={index} className="flex flex-col rounded-xl border border-gray-200 text-gray-600 duration-300 hover:shadow-2xl focus:shadow-2xl outline-none shadow-blue-500/20">
                <div className="p-4 md:p-5">
                  <div className="flex justify-between items-center gap-x-3">
                    <div className="grow">
                      <h3 className="font-semibold">
                        {tool.title}
                      </h3>
                    </div>
                    <div>
                      <svg className="shrink-0 size-5" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="m9 18 6-6-6-6"/></svg>
                    </div>
                  </div>
                </div>
              </Link>
            )} )}

          </div>
        </div>

      </section>

    </>
  )
}

export default HomePage